import { render, staticRenderFns } from "./TimeClock.vue?vue&type=template&id=1edd974c&scoped=true&"
import script from "./TimeClock.vue?vue&type=script&lang=js&"
export * from "./TimeClock.vue?vue&type=script&lang=js&"
import style0 from "./TimeClock.vue?vue&type=style&index=0&id=1edd974c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd974c",
  null
  
)

export default component.exports